    /* =====================================================================
   BundleAccessorySelector — DOM controller for the shared accessory panel
   =====================================================================
   Mirrors the legacy in-line accessory behavior: multi-select checkboxes,
   per-card quantity stepper, "None" clear, "+N more" expand. Backed by a
   BundleAddonCore.AddonLineStore. Exposes getLines/getCartItems/getTotal/clear.
   ===================================================================== */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function BundleAccessorySelector(root, opts) {
    if (!root) return;
    opts = opts || {};
    var Core = window.BundleAddonCore;
    this.root = root;
    this.store = new Core.AddonLineStore(opts.onChange || function () {});
    this._bind();
    this._initQtyButtons();
    this._repaintNone();
  }

  BundleAccessorySelector.prototype._card = function (variant) {
    return this.root.querySelector('[data-accessory-card][data-variant="' + variant + '"]');
  };

  BundleAccessorySelector.prototype._bind = function () {
    var self = this;
    this.root.addEventListener('change', function (ev) {
      var input = ev.target.closest('[data-accessory-input]');
      if (input) self._toggle(input);
    });
    this.root.addEventListener('click', function (ev) {
      var qtyBtn = ev.target.closest('[data-accessory-qty]');
      if (qtyBtn) { ev.preventDefault(); ev.stopPropagation(); self._qty(qtyBtn); return; }
      if (ev.target.closest('[data-accessory-none]')) { ev.preventDefault(); self.clear(); return; }
      var more = ev.target.closest('[data-accessory-more]');
      if (more) { ev.preventDefault(); more.remove(); return; }
    });
  };

  BundleAccessorySelector.prototype._toggle = function (input) {
    var card = input.closest('[data-accessory-card]');
    if (!card) return;
    var variant = parseInt(card.dataset.variant, 10);
    var price = parseInt(card.dataset.price, 10) || 0;
    var label = card.dataset.label || '';
    if (input.checked) {
      this.store.upsert({ id: variant, quantity: 1, price: price, label: label });
    } else {
      this.store.remove(variant);
    }
    this._repaintQty(variant);
    this._repaintNone();
  };

  // Same idle-stepper treatment as the cable panel: steppers stay clickable
  // when the card is unselected, "+" selects at qty 1, "−" to 0 deselects.
  BundleAccessorySelector.prototype._initQtyButtons = function () {
    var self = this;
    this.root.querySelectorAll('[data-accessory-card]').forEach(function (card) {
      self._repaintQty(parseInt(card.dataset.variant, 10));
    });
  };

  BundleAccessorySelector.prototype._qty = function (button) {
    if (button.disabled) return;
    var variant = parseInt(button.dataset.variant, 10);
    if (!this.store.has(variant)) {
      if (button.dataset.action !== 'inc') return;
      var idleCard = this._card(variant);
      var input = idleCard && idleCard.querySelector('[data-accessory-input]');
      if (input && !input.checked && !input.disabled) {
        input.checked = true;
        this._toggle(input);
      }
      return;
    }
    var cur = this.store.getQty(variant);
    var next = button.dataset.action === 'inc' ? cur + 1 : cur - 1;
    if (next <= 0) {
      var offCard = this._card(variant);
      var offInput = offCard && offCard.querySelector('[data-accessory-input]');
      if (offInput) offInput.checked = false;
      this.store.remove(variant);
      this._repaintQty(variant);
      this._repaintNone();
      return;
    }
    var card = this._card(variant);
    this.store.upsert({
      id: variant,
      quantity: next,
      price: card ? (parseInt(card.dataset.price, 10) || 0) : 0,
      label: card ? (card.dataset.label || '') : ''
    });
    var valEl = this.root.querySelector('[data-accessory-qty-val][data-variant="' + variant + '"]');
    if (valEl) valEl.textContent = String(next);
  };

  BundleAccessorySelector.prototype._repaintQty = function (variant) {
    var wrap = this.root.querySelector('[data-accessory-qty-wrap][data-variant="' + variant + '"]');
    if (!wrap) return;
    var on = this.store.has(variant);
    wrap.querySelectorAll('[data-accessory-qty]').forEach(function (b) {
      b.disabled = false;
      b.classList.toggle('is-idle', !on);
    });
    var valEl = wrap.querySelector('[data-accessory-qty-val]');
    if (valEl) valEl.textContent = on ? String(this.store.getQty(variant)) : '0';
    var card = this._card(variant);
    if (card) {
      var label = card.querySelector('.pbundle__opt');
      if (label) label.classList.toggle('is-selected', on);
    }
  };

  BundleAccessorySelector.prototype._repaintNone = function () {
    var noneEl = this.root.querySelector('[data-accessory-none]');
    if (!noneEl) return;
    var empty = this.store.getLines().length === 0;
    noneEl.classList.toggle('is-selected', empty);
    noneEl.setAttribute('aria-pressed', empty ? 'true' : 'false');
  };

  BundleAccessorySelector.prototype.clear = function () {
    this.store.clear();
    var self = this;
    this.root.querySelectorAll('[data-accessory-input]').forEach(function (i) { i.checked = false; });
    this.root.querySelectorAll('[data-accessory-card]').forEach(function (card) {
      self._repaintQty(parseInt(card.dataset.variant, 10));
    });
    this._repaintNone();
  };

  BundleAccessorySelector.prototype.getLines = function () { return this.store.getLines(); };
  BundleAccessorySelector.prototype.getCartItems = function () { return this.store.getCartItems(); };
  BundleAccessorySelector.prototype.getTotal = function () { return this.store.getTotal(); };

  window.BundleAccessorySelector = BundleAccessorySelector;
})();
